<template>
  <div class="chat--footer--actions">
    <button
      :title="$t('conversation.footer.selectEmoji')"
      :aria-label="$t('conversation.footer.selectEmoji')"
      type="button"
      class="footer-icon"
      :style="dynamicColors"
      :disabled="disableVoiceRecording"
      @click="toggleEmojiPage()"
    >
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 17 17"
        style="enable-background: new 0 0 17 17"
      >
        <use xlink:href="#widget-chat-icon-emoji" />
      </svg>
    </button>

    <button
      :title="$t('conversation.footer.sendAttachment')"
      :aria-label="$t('conversation.footer.sendAttachment')"
      type="button"
      class="footer-icon"
      :style="dynamicColors"
      :disabled="disableAttachment"
      @click="handleUploadFile()"
    >
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 17 17"
        style="enable-background: new 0 0 17 17"
      >
        <use xlink:href="#widget-chat-icon-attachment" />
      </svg>
    </button>

    <ConversationVoiceRecorder
      v-if="isRecordingAble && !comment && !dragging && !inBotConversation"
      @startRecording="handleStartRecording"
      @stopRecording="handleStopRecording"
    />

    <button
      id="sendButton"
      :disabled="disableSendButton"
      type="button"
      :title="$t('conversation.footer.buttonSend')"
      :aria-label="$t('conversation.footer.buttonSend')"
      class="footer-icon send--icon"
      :style="`color: rgb(${settings.bgColorRGB}); background: `"
      @click="handleSendMessage()"
    >
      <svg viewBox="0 0 16 12" width="20" height="20">
        <use xlink:href="#send--icon-2" />
      </svg>
    </button>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import { navigatorUtil } from '@/helpers'

  import ConversationVoiceRecorder from './voice-recorder/ConversationVoiceRecorder'

  export default {
    components: {
      ConversationVoiceRecorder
    },
    props: {
      getFooterHeight: {
        type: Function,
        required: true
      },
      handleSendMessage: {
        type: Function,
        required: true
      },
      sending: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        isRecordingAble: false
      }
    },
    computed: {
      ...mapGetters([
        'settings',
        'emojiPageStatus',
        'comment',
        'isVoiceRecording',
        'dragging',
        'disableUserInput',
        'showNumberInput',
        'numberInputValid',
        'inBotConversation'
      ]),
      dynamicColors() {
        return {
          '--button-active-bg': `rgba(${this.settings.bgColorRGBA})`
        }
      },
      disableVoiceRecording() {
        return (
          this.isVoiceRecording ||
          this.disableUserInput ||
          this.showNumberInput ||
          this.inBotConversation
        )
      },
      disableAttachment() {
        return (
          this.comment ||
          this.isVoiceRecording ||
          this.dragging ||
          this.inBotConversation
        )
      },
      disableSendButton() {
        return (
          this.sending ||
          !this.comment ||
          this.isVoiceRecording ||
          this.disableUserInput ||
          (this.showNumberInput && !this.numberInputValid)
        )
      }
    },
    mounted() {
      this.isRecordingAble = navigatorUtil.isRecordingAble()
    },
    methods: {
      ...mapActions([
        'disableEmojiPage',
        'enableEmojiPage',
        'setVoiceRecording'
      ]),
      handleUploadFile() {
        document.querySelector('.dropzone').click()
      },
      handleStartRecording() {
        this.setVoiceRecording(true)

        this.getFooterHeight()
      },
      handleStopRecording() {
        this.setVoiceRecording(false)

        this.getFooterHeight()
      },
      toggleEmojiPage() {
        if (!this.emojiPageStatus) {
          this.enableEmojiPage()
        } else {
          this.disableEmojiPage()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  div.chat--footer--actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    button.footer-icon {
      width: 20px;
      height: 20px;
      background: transparent;
      cursor: pointer;
      opacity: 1;
      border-radius: 100%;
      position: relative;
      z-index: 1;
      fill: #aeaeb0;
      transition: background-color 400ms, transform 200ms;
      margin-right: 0.2rem;
      margin-left: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 16px;
        height: 16px;
      }
      &:disabled {
        transform: scale(0);
        opacity: 0;
        position: absolute;
        z-index: 0;
      }
      &:hover,
      &:focus {
        opacity: 1;
        color: var(--button-active-bg);
      }
      &.send--icon {
        color: var(--button-active-bg);
      }
    }
  }
</style>
